import { SVGProps } from 'react'

import { SpinnerIcon } from '../../../icons'

import styles from './spinner.module.css'

export const Spinner = (props: SVGProps<SVGSVGElement>) => {
  return <SpinnerIcon {...props} className={styles.spinner} />
}
